import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';

// Consulting layer (spec 11.2): cross-engine synthesis. One deterministically-ranked agenda
// item per threatened money-node, merging the signals that share it. Read-only.

const SEVERITY_TAG: Record<string, string> = {
  existential: 'red',
  high: 'red',
  elevated: 'amber',
  watch: 'muted',
};

export default function Synthesis() {
  const synthesis = useQuery({ queryKey: ['synthesis'], queryFn: api.synthesisAgenda });

  if (synthesis.isLoading) return <div className="small faint">Loading synthesis agenda…</div>;
  if (synthesis.isError || !synthesis.data) return <div className="small faint">Synthesis unavailable.</div>;

  const { agenda, coverage_note } = synthesis.data;

  return (
    <div>
      <div className="ph">Consulting · Cross-Engine Synthesis</div>
      <div className="h2">{agenda.length} ranked agenda item{agenda.length === 1 ? '' : 's'}</div>
      <p className="lead">{coverage_note}</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(420px, 1fr))', gap: 12 }}>
        {agenda.map((item) => (
          <div key={item.money_node_id} className="driftcard">
            <div className="row" style={{ justifyContent: 'space-between', marginBottom: 8 }}>
              <span className="tag teal">{item.money_node_id} · {item.money_node_stage}</span>
              <span className={`tag ${SEVERITY_TAG[item.severity] ?? 'muted'}`}>{item.severity}</span>
            </div>
            <div className="small" style={{ lineHeight: 1.5, color: 'var(--ink)', marginBottom: 10 }}>{item.headline}</div>
            <div className="row" style={{ gap: 12, flexWrap: 'wrap' }} >
              <span className="small faint">~${item.combined_risk_usd_m[0]}–${item.combined_risk_usd_m[1]}M</span>
              <span className="small faint">{item.signal_count} signals · {item.breached_count} breached</span>
              <span className="small faint">Engines {item.engines.join(', ')}</span>
              <span className="small faint">Objectives {item.objective_ids.join(', ')}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
